
import { defineComponent, Ref, ref, onMounted, onUnmounted, watch } from "vue";
import { Modal } from "bootstrap";
import Api from "@/services/Api"
import useAlert from "@/composables/Alert";
import useEmitter from "@/composables/Emmiter";
import ModalInfoVeiculo from "./ModalInfoVeiculo.vue";

interface Produto {
  id_filtro: number | null;
  nome: string | null;
  idMarca: number | null;
  idTipo: number | null;
  tipo: string | null;
  marca: string | null;
  editando: boolean | null;
  adicionar: boolean | null;
}

export default defineComponent({
  name: "EditaVeiculo",

  components: { 
    ModalInfoVeiculo
  },
  props: {
    fechaModal: Function,
    veiculos: Array,
  },

  setup(props) {
    const { showTimeAlert } = useAlert();
    const emitter = useEmitter();


    const loadingSalva: Ref<boolean> = ref(false);
    const veiculos: Ref<any[]> = ref([]);

    const arrayMarcas: Ref<any[]> = ref([]);
    const arrayTipos: Ref<any[]> = ref([]);

    const produtoVeiculo: Ref<Produto[]> = ref([]);
    const produtoCopiado: Ref<Produto[]> = ref([]);

    const copiado: Ref<boolean> = ref(false);



    const tipoSelecionado: Ref<string> = ref('filtro_oleo');
    const modoExibicao: Ref<string> = ref('visualizar');









    const getMarcaProduto = async() => arrayMarcas.value = <any[]> (await Api.get('getMarcasProdutoDbInfo', {tipoProduto: 'filtros'})).data
    const getTipoProduto = async() => arrayTipos.value = <any[]> (await Api.get('getTipoProdutoFiltros')).data
    
    

    const modelosPorLinha: Ref<Record<number, any[]>> = ref({});
    const carregandoModelos: Ref<Record<number, boolean>> = ref({});


    function adicionaProduto() {

      const tipo = arrayTipos.value.find(e=> e.nome === tipoSelecionado.value) 

      produtoVeiculo.value.push({ id_filtro: null, nome: '', idMarca: null, idTipo: tipo.id_tipo_produto, tipo: tipo.nome, marca: null, editando: true, adicionar: true })

    }

    function removeProduto(index: number) {

      produtoVeiculo.value.splice(index, 1)

    }

    function editarProduto(index: number) {
      
      produtoVeiculo.value[index].editando = true;

      // Dispara a busca de modelos para os itens carregados
      const prod = produtoVeiculo.value[index];
      if(prod.idMarca) buscarModelos(index);
    }

    function fecharEdicaoProduto(index: number) {
      const produto = produtoVeiculo.value[index];

      // 1. Atualiza o texto da Marca para a visualização
      if (produto.idMarca) {
        const marcaEncontrada = arrayMarcas.value.find(m => m.id_marca_produto === produto.idMarca);
        if (marcaEncontrada) {
          produto.marca = marcaEncontrada.nome;
        }
      } else {
        produto.marca = '';
      }

      // 2. Atualiza o texto do Modelo (nome) para a visualização
      if (produto.id_filtro) {
        const listaModelos = modelosPorLinha.value[index] || [];
        const modeloEncontrado = listaModelos.find(m => m.id === produto.id_filtro);
        if (modeloEncontrado) {
          produto.nome = modeloEncontrado.nome;
        }
      } else {
        produto.nome = '';
      }

      // 3. Agora sim, volta para o modo somente leitura
      produto.editando = false;
    }

    function copiarProdutos() {
      copiado.value = !copiado.value
      produtoCopiado.value = produtoVeiculo.value;
    }

    function colarProdutos() {
      produtoVeiculo.value = produtoCopiado.value
    }

    async function carregaProduto() {
      if(!veiculos.value || veiculos.value.length !== 1) return;

      const { data } = await Api.get('carregaProduto', { ...veiculos.value[0]} );

      produtoVeiculo.value = data.produtos.map((e, index) => {
        if (e.id_filtro && e.nome) {
          modelosPorLinha.value[index] = [{ 
            id: Number(e.id_filtro), 
            nome: e.nome 
          }];
        }

        return {
          ...e, 
          idMarca: Number(e.idMarca),
          idTipo: Number(e.idTipo),
          id_filtro: Number(e.id_filtro),
          editando: false
        };
      });
    }

    const buscarModelos = async (index: number) => {
      const produto = produtoVeiculo.value[index];
      
      // Se resetar a marca, limpa os modelos e o nome selecionado
      if (!produto.idMarca) {
        modelosPorLinha.value[index] = [];
        produto.nome = '';
        return;
      }


      carregandoModelos.value[index] = true;
      
      try {
        const { data } = await Api.get('getFiltrosPorMarcaTipo', { idMarca: produto.idMarca, tipo: produto.tipo });
        
        // // Armazena a lista de modelos específica para este índice
        // modelosPorLinha.value[index] = data.filtros.map((f: any) => ({ id: f.id_filtro, nome: f.nome }));

        // 1. Pegamos todos os IDs de filtros que já estão na lista (exceto o da linha atual)
        const idsJaSelecionados = produtoVeiculo.value
          .filter((p, idx) => idx !== index && p.id_filtro) // ignora a linha atual e linhas sem filtro
          .map(p => Number(p.id_filtro));

        // 2. Filtramos a resposta da API para remover os IDs duplicados
        const filtrosFiltrados = data.filtros
          .map((f: any) => ({ id: Number(f.id_filtro), nome: f.nome }))
          .filter(f => !idsJaSelecionados.includes(f.id));

        // 3. Armazena apenas os que sobraram
        modelosPorLinha.value[index] = filtrosFiltrados;
      } catch (error) {
        console.error("Erro ao buscar modelos", error);
      } finally {
        carregandoModelos.value[index] = false;
      }
    };

    
    async function salvaModificacao() {

      try {
        
        loadingSalva.value = true;

        const { data } = await Api.post('salvaModificacaoVeiculo', { veiculos: veiculos.value, produtos: produtoVeiculo.value})
  
        enviaVeiculosEditados()

        await carregaProduto();

        produtoVeiculo.value.forEach((prod, index) => {
          prod.editando = false; // Fecha a edição para todos os produtos
        });
  
        loadingSalva.value = false;

        if(!data.modificacaoSalva) return showTimeAlert("Não foi possível salvar a alteração!");
  
        showTimeAlert("A alteração foi salva com sucesso!");
        
      } catch (error) { showTimeAlert("Não foi possível salvar a alteração!"); } finally { loadingSalva.value = false; }

    }

   
    function pegaModal(id: string) {
      const el = document.querySelector(`#${id}`);

      if (!el) return null;

      return Modal.getInstance(el) || new Modal(el);
    }

    const openModal = (id: string) => {
      pegaModal(id)?.show();
    };

    async function fechaModalInfoVeiculo() {
      pegaModal("infoVeiculo")?.hide();
    }

    function enviaVeiculosEditados() {

      const produto = {
        filtro_oleo: produtoVeiculo.value.filter((e)=> e.tipo == 'filtro_oleo').length,
        filtro_ar: produtoVeiculo.value.filter((e)=> e.tipo == 'filtro_ar').length,
        filtro_ac: produtoVeiculo.value.filter((e)=> e.tipo == 'filtro_ac').length,
        filtro_combustivel: produtoVeiculo.value.filter((e)=> e.tipo == 'filtro_combustivel').length,
        filtros: produtoVeiculo.value.length,
      }

      emitter.emit("atualiza-lista-veiculos", { veiculos: veiculos.value, produtos: produto } )
    }

    watch(
      () => props.veiculos,
      async (novosVeiculos) => {
        veiculos.value = Array.isArray(novosVeiculos) ? [...novosVeiculos] : [];

        if (!veiculos.value || veiculos.value.length !== 1) {
          produtoVeiculo.value = [];
          return;
        }

        await carregaProduto();
      },
      { immediate: true, deep: true }
    );


    onMounted(async() => {
      getMarcaProduto();
      getTipoProduto();
    })

    onUnmounted(() =>{

    });

    const dismiss = () => {

      produtoVeiculo.value = [];
      props.fechaModal && props.fechaModal();

    }

   

    return { dismiss, salvaModificacao, veiculos, arrayMarcas, tipoSelecionado, produtoVeiculo, adicionaProduto, removeProduto, copiarProdutos, colarProdutos, produtoCopiado, copiado, loadingSalva, openModal, fechaModalInfoVeiculo, buscarModelos, modelosPorLinha, carregandoModelos, modoExibicao, editarProduto, fecharEdicaoProduto}
  }

})

